import { render, staticRenderFns } from "./CreateContactForm.vue?vue&type=template&id=0e96a47a"
import script from "./CreateContactForm.vue?vue&type=script&lang=js"
export * from "./CreateContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports